
import React, { useEffect } from "react";
import { useRecipeUrlForm } from "@/hooks/useRecipeUrlForm";
import RecipeUrlInput from "@/components/recipe/RecipeUrlInput";
import RecipeUrlInputInline from "@/components/recipe/RecipeUrlInputInline";
import RecipeProcessingStatus from "@/components/recipe/RecipeProcessingStatus";
import RecipeProcessingStatusInline from "@/components/recipe/RecipeProcessingStatusInline";
import RecipeSuccessDialog from "@/components/recipe/RecipeSuccessDialog";

interface RecipeUrlFormProps {
  onRecipeAdded: () => void;
  onImportComplete?: () => void;
  initialUrl?: string;
  variant?: "default" | "inline";
  onLoadingChange?: (loading: boolean) => void;
  suggestionId?: string;
}

const RecipeUrlForm = ({ 
  onRecipeAdded, 
  onImportComplete,
  initialUrl = "", 
  variant = "default", 
  onLoadingChange,
  suggestionId 
}: RecipeUrlFormProps) => {
  const {
    url,
    setUrl,
    isLoading,
    processingStage,
    progress,
    successData,
    handleSubmit,
    handleDialogClose
  } = useRecipeUrlForm({ onRecipeAdded, initialUrl, suggestionId });

  // Notify parent component when loading state changes
  useEffect(() => {
    if (onLoadingChange) {
      onLoadingChange(isLoading);
    }
  }, [isLoading, onLoadingChange]);

  const handleSuccessDialogClose = () => {
    handleDialogClose();
    // Call the import completion callback after the dialog is closed
    if (onImportComplete) {
      onImportComplete();
    }
  };

  const UrlInputComponent = variant === "inline" ? RecipeUrlInputInline : RecipeUrlInput;
  const ProcessingStatusComponent = variant === "inline" ? RecipeProcessingStatusInline : RecipeProcessingStatus;

  return (
    <>
      <UrlInputComponent
        url={url}
        setUrl={setUrl}
        onSubmit={handleSubmit}
        isLoading={isLoading}
      />
      
      <ProcessingStatusComponent
        isLoading={isLoading}
        processingStage={processingStage}
        progress={progress}
      />

      {successData && (
        <RecipeSuccessDialog
          isOpen={!!successData}
          onOpenChange={handleSuccessDialogClose}
          recipeTitle={successData.title}
          recipeId={successData.id}
          isEditing={false}
        />
      )}
    </>
  );
};

export default RecipeUrlForm;
